import {useEffect,} from 'react';

import {useAccountApplications} from '../hooks/useAccountApplications';
import {
    Box,
    SimpleGrid,
    Table
} from "@mantine/core";
import {
    SimpleTableBatchAction,
    SimpleTablePagination
} from "@flexinet/ui-components";
import {AccountApplication} from "../types.ts";
import {AccountApplicationGridProfile} from "../profile/AccountApplicationGridProfile.tsx";
import {useUserAccount} from '../../../../hooks/useUserAccount.ts';
import {useAccountApplicationUrlFragment} from "../hooks/useAccountApplicationUrlFragment.tsx";


export const AccountApplicationsGrid = () => {

    const {
        userAccount,
    } = useUserAccount();

    if (!userAccount) {
        throw new Error('user account is required parameter')
    }

    const {urlFragment} = useAccountApplicationUrlFragment();

    const {
        visibleItems,
        limit,
        totalPages,
        visibleCount,
        fetchRecords,
        handleFilterByKeyword,
        handleItemsPerPageChange,
        handlePageChange,
    } = useAccountApplications(userAccount.id);


    useEffect(() => {
        fetchRecords();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={handleItemsPerPageChange}
                settings={[]}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={[]}
            />
            <Table verticalSpacing='sm' striped highlightOnHover>

                <SimpleGrid
                    cols={{
                        base: 4,
                        xl: 4,
                        lg: 4,
                        md: 3,
                        sm: 2,
                        xs: 1
                    }}
                >
                    {visibleItems.map((accountApplication: AccountApplication, index: number) => {

                        const cloudApplication = Object.assign({}, accountApplication.application, {
                            'linkFragment': urlFragment,
                        });

                        return (
                            <Box key={index}>
                                <AccountApplicationGridProfile cloudApplication={cloudApplication}/>
                            </Box>
                        );
                    })}
                </SimpleGrid>


            </Table>

            <SimpleTablePagination
                totalPages={totalPages}
                visibleCount={visibleCount}
                handlePageChange={handlePageChange}
            />
        </SimpleGrid>

    )

};
